<script>
    // CommitChart.js
    import {Line} from 'vue-chartjs'

    export default {
        extends: Line,
        data() {
            return {
                lastData: this.data
            }
        },
        props: {
            labels: {
                required: true,
                type: Array
            },
            unit: {
                type: String,
                default: ''
            },
            digits: {
                type: Number,
                default: 0
            },
            data: {
                required: true,
                type: Array
            },
            title: {
                type: String,
                default: ''
            },
          width: {
              type: Number,
              default:1000
          },
          height: {
              type: Number,
              default:400
          }
        },
        mounted() {
            this.renderLineChart(false);
        },
        computed: {
            chartData: function () {
                return this.data;
            }
        },
        methods: {
            renderLineChart: function (animated = false) {
                this.$refs.canvas.style['max-width'] = this.width;
                this.$refs.canvas.style['max-height'] = this.height;
                const options = {
                    responsive: false,
                    //  maintainAspectRatio: false,
                    animation: {
                        duration: animated ? 1000 : 0
                    },
                    legend: {
                        display: true,
                    },
                    /*tooltips: {
                        callbacks: {
                            title: function (tooltipItems) {
                                return typeof tooltipItems[0] !== 'undefined' ? tooltipItems[0].label : '';
                            }.bind(this),
                            label: function (tooltipItem, data) {
                                let number = data['datasets'][0]['data'][tooltipItem['index']]
                                number = parseFloat(number);
                                number = number.toLocaleString('de-DE', {
                                    minimumFractionDigits: this.digits,
                                    maximumFractionDigits: this.digits
                                });
                                return number + ' ' + this.unit;
                            }.bind(this)
                        }
                    },*/
                    scales: {
                        yAxes: [

                            {
                                ticks: {
                                    callback: function(label) {
                                        label = parseFloat(label);
                                        let digits = this.unit === "€" && label<0 ? 2 : 0
                                        label = label.toLocaleString('de-DE', {
                                            minimumFractionDigits: digits,
                                            maximumFractionDigits: digits
                                        });
                                        return label + ' ' + this.unit;
                                    }.bind(this),
                                    beginAtZero: true,
                                    fontStyle: 'bold'
                                }
                            }],
                        xAxes: [{
                            ticks: {
                                fontStyle: 'bold'
                            }
                        }]
                    },
                    title: {
                        display: this.title !== '',
                        text: this.title,
                        fontSize: 12
                    }
                };
                // Overwriting base render method with actual data.
                this.renderChart({
                    labels: this.labels,
                    datasets: this.data
                }, options)
            },
            arrayDiff(a, b) {
                return [...b.reduce((acc, v) => acc.set(v, (acc.get(v) || 0) - 1),
                    a.reduce((acc, v) => acc.set(v, (acc.get(v) || 0) + 1), new Map())
                )].reduce((acc, [v, count]) => acc.concat(Array(Math.abs(count)).fill(v)), []);
            }
            ,
            reRender(animated) {
                this._data._chart.destroy();
                this.renderLineChart(animated);
            }
        },
        watch: {
            data: function () {
                if (this.arrayDiff(this.data, this.lastData).length > 0) {
                    this.lastData = this.data;
                    this.reRender(true);
                }
            }
        }

    }
</script>

<style scoped>

    canvas {
        background-color: white;
        padding: 12px;
        margin: auto;

    }


</style>